angular.module('ikeweb.folders', [
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.repository.parse',
    'ikeweb.repository',
    'ikeweb.shared.logging',
    'ikeweb.error',
    'ikeweb.event',
    'LocalStorageModule',
    'pascalprecht.translate'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folders.module.js
// module id = 418
// module chunks = 0